// extracted by mini-css-extract-plugin
export var itemsContainer = "styles-module--itemsContainer--2iacZ";
export var cta = "styles-module--cta--2kk0Q";
export var item = "styles-module--item--1XvB7";
export var image = "styles-module--image--19jQG";
export var title = "styles-module--title--aR1KQ";
export var subtitle = "styles-module--subtitle--2PwIK";
export var content = "styles-module--content--2VJ79";